export const getAccount = ({ address, initCode, type, deployedOnChains = [], }) => {
    return {
        address,
        initCode,
        type,
        deployedOnChains,
    };
};
//# sourceMappingURL=getAccount.js.map